export default __webpack_public_path__ + "assets/images/q_and_a_3uDMG.jpg";